import { call, put, takeLatest } from "@redux-saga/core/effects";
import UserService from "../../Services/RestApiManager/UserManager/UserService";
import { errorBudgetReport, errorGenerateReport, errorReportsProjects, REPORTS_ACTION, responseBudgetReport, responseGenerateReport, responseReportsProjects } from "./ReportsActionCreator";
import ReportsService from "../../Services/RestApiManager/ReportsManager/ReportsService";

export function* ReportsProjectsRequest(action) {
    try {
      const response = yield call(ReportsService.shared.reportsProjectsByIdRequest, action.data);
      yield put(responseReportsProjects(response));
    } catch (error) {
      yield put(errorReportsProjects(error));
    }
  }

  export function* BudgetReportRequest(action) {
    try {
      const response = yield call(ReportsService.shared.BudgetReportByProjectRequest, action.data);
      yield put(responseBudgetReport(response));
    } catch (error) {
      yield put(errorBudgetReport(error));
    }
  }

  export function* GenerateReportRequest(action) {
    try {
      const response = yield call(ReportsService.shared.generateReportRequest, action.data);
      yield put(responseGenerateReport(response));
    } catch (error) {
      yield put(errorGenerateReport(error));
    }
  }

  export function* reportsWatcherSaga() {
    yield takeLatest(REPORTS_ACTION.REQUEST_REPORTS_PROJECTS, ReportsProjectsRequest);
    yield takeLatest(REPORTS_ACTION.REQUEST_GENERATE_REPORT, GenerateReportRequest);
    yield takeLatest(REPORTS_ACTION.REQUEST_BUDGET_REPORTS, BudgetReportRequest);
  }

  